<div class="card" *ngIf="subTopic">
    <div class="card-header">
        <h4 class="text-center">Sub Topic Name: {{subTopic.name}}</h4>
    </div>
    <div class="card-body">
              <table class="table table-striped">
              <tbody>
                <tr><td>Date Created</td><td>{{subTopic.datecreated}}</td></tr>
                <tr><td>Last Updated</td><td>{{subTopic.lastupdated}}</td></tr>
                <tr><td>Name</td><td>{{subTopic.name}}</td></tr>
                <tr><td>Description</td><td>{{subTopic.description}}</td></tr>
                <tr><td>Code</td><td>{{subTopic.subtopiccode}}</td></tr>
                <tr><td>Is Open</td><td>{{subTopic.is_open}}</td></tr>
                <tr><td>Topic </td><td><a [routerLink]="['/admin/topic/show',serverTopicId]">{{topicName}}</a></td></tr>
                </tbody>
                </table>


                <h6 class="alert alert-info text-center"> Task Templates</h6>
                <table *ngIf="subTopic['taskTemplates']"  class='table table-sm table-striped'>
                  <thead>
                   <tr>
                     <th>Name</th>
                     <th>Enabled</th>
                     <th>Answer</th>
                     <th>Mode</th>
                     <th>Remove</th>

                    </tr>
                  </thead>

                  <tbody>
                   <tr *ngFor="let taskTemplate of subTopic['taskTemplates'];">
                     <td>
                         <a [routerLink]="['/task/template/show',taskTemplate.id]">{{taskTemplate.name}}</a>
                     </td>
                     <td><span>{{taskTemplate.enabled==1?'Yes':'No'}}</span></td>
                     <td>{{taskTemplate.answerTemplateName}}</td>
                     <td>STANDARD</td>
                     <td><a  (click)="onRemoveTemplate(taskTemplate.id)" class="delete btn btn-danger">X</a></td>
                   </tr>
                   </tbody>
                   </table>



               <div *ngIf="facts">

                <h6 class="alert alert-info text-center"> Facts</h6>
                <table *ngIf="subTopic['facts']" class="table">
                  <thead>
                    <tr>
                      <th>Body</th>
                      <th>Truth</th>
                      <th>Explanation</th>
                      <th>Mode</th>
                      <th>Remove</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let trivialTemplate of subTopic['facts'];">
                    <td>
                        <a [routerLink]="['/admin/fact/show',trivialTemplate.server_fact_id]">{{trivialTemplate.body}}</a>
                    </td>
                    <td>{{trivialTemplate.truth}}</td>
                    <td>{{trivialTemplate.explanation}}</td>
                    <td>TRIVIAL</td>
                    <td><a  (click)="onRemoveFact(trivialTemplate.server_fact_id)" class="delete btn btn-danger">X</a></td>
                  </tr>
                </tbody>
                </table>
               </div>



                <h6 class="alert alert-info text-center"> Proficiencies</h6>
                  <table class='table table-sm table-striped'>
                    <thead>
                      <tr>
                        <th>Description</th>
                        <th>Ordering</th>
                        <th>Templates</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                   <tbody>
                    <tr *ngFor="let proficiency of subTopic.proficiencies;">
                      <td>{{proficiency.description}}</td>
                      <td>
                        {{proficiency.ordering}}
                        <app-add-proficiency [subTopic]="subTopic" [proficiency]="proficiency" (addProficiencyFinished)="onAddProficiencyFinished(proficiency.server_proficiency_id)" *ngIf="subTopic.server_subtopic_id!=0"> </app-add-proficiency>
                      </td>
                      <td>
                        <ul *ngFor="let tt of proficiency.templates">
                          <li>
                            {{tt['name']}}
                             <a (click)="removeProficiencyTemplateAlert(proficiency.server_proficiency_id,tt['server_task_template_id'])" class="me-3 text-danger btn btn-primary"><i class="fa fa-minus"></i> Remove</a>
                          </li>
                        </ul>
                      </td>
                      <td>
                        <a (click)="addProficiencyPopUp(proficiency.server_proficiency_id)" class="me-3 btn btn-primary"><i class="fa fa-plus"></i> Edit</a>
                        <a [routerLink]="['/admin/proficiency/add/template',proficiency.server_proficiency_id,proficiency.server_subtopic_id]" class="me-3 btn btn-primary"><i class="fa fa-plus"></i> Template</a>
                        <a (click)="deleteProficiencyAlert(proficiency.server_proficiency_id)" class="me-3 text-danger btn btn-primary"><i class="fa fa-minus"></i> Delete</a>
                      </td>
                    </tr>
                   </tbody>
                  </table>


    </div>

    <app-admin-syllabus-subtopic-edit [subTopic]="subTopic" (editSubTopicFinished)="reloadTopic()" *ngIf="subTopic.server_subtopic_id!=0"> </app-admin-syllabus-subtopic-edit>
    <app-add-proficiency [subTopic]="subTopic" [proficiency]="newProficiency" (addProficiencyFinished)="onAddProficiencyFinished(0)" *ngIf="subTopic.server_subtopic_id!=0"> </app-add-proficiency>
    <div class="card-footer">
            <fieldset class="buttons text-center alert">
                <a [routerLink]="['/admin/subtopic/template/task/add',subTopic.id]" class="edit btn btn-primary me-3"><i class="fa fa-plus"></i>Template</a>
                <a [routerLink]="['/admin/concept/add',subTopic.id]" class="edit btn btn-primary me-3"><i class="fa fa-plus"></i> Add Concept</a>
                <button  class="btn btn-primary me-2" (click)="editSubTopicPopUp()"><i class="fa fa-edit"></i> Edit</button>

                <a [routerLink]="['/admin/syllabus/show',serverSyllabusId]" class="edit btn btn-primary mx-3"> Syllabus</a>
                <a [routerLink]="['/task/template/load']" class="btn btn-primary me-2" > <i class="fa fa-plus"> </i> Load Task Template </a>
                <a [routerLink]="['/admin/fact/subtopic',subTopic.server_subtopic_id]" class="btn btn-primary mx-3" > <i class="fa fa-list"> </i> Facts </a>
                <a (click)="addProficiencyPopUp(0)" class="edit btn btn-primary me-3"><i class="fa fa-plus"></i> Proficiency</a>
                <a class="btn btn-primary mx-3"  (click)="onMoveSubTopic()" class="delete btn btn-danger" >Move</a>
            </fieldset>
    </div>
</div>
<app-loading *ngIf="!subTopic"></app-loading>




